/**
 * P-56 (D-231 §6) — an AI feature used while the provider has no API key. The
 * server answers 422 with the stable `error_code: 'AI_NOT_CONFIGURED'`; the UI
 * shows ONE clear Hebrew line (what happened + who must do what), never the
 * technical "API key not configured" / "AI parsing failed: ...".
 */
export const AI_NOT_CONFIGURED = 'AI_NOT_CONFIGURED';

export function isAiNotConfigured(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false;
  const e = err as { error?: { error_code?: string } | string; response?: { data?: { error?: { error_code?: string } } } };
  const code = (typeof e.error === 'object' ? e.error?.error_code : undefined) ?? e.response?.data?.error?.error_code;
  return code === AI_NOT_CONFIGURED;
}

/** The text for a failed AI call: the "not configured" line, else the caller's fallback. */
export function aiErrorText(err: unknown, notConfigured: string, fallback: string): string {
  return isAiNotConfigured(err) ? notConfigured : fallback;
}
